import React, {Fragment} from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import createForm from "./Form";
import {CurrencyFormatter, UnitFormatter} from "../../../utils/formatters";
import isEqual from "lodash-es/isEqual";
import classNames from 'classnames';
import ComponentConfig from "../../form/ComponentConfig";
import Icon from "../../form/Icon";
import MoneyTransferList from "../lists/MoneyTransferList";
import {postData, sendRequest} from "../../../utils/request";
import Collapse from "../../layout/Collapse";
import Button from "../../form/Button";
import {calcClassName, isEmpty, isFalse, isTrue} from "../../../utils/other";
import {saveComponent} from "../../../utils/components";
import TextArea from "../../form/TextArea";
import Portal from "../../layout/Portal";
import Modal from "../../layout/Modal";
import {Tooltip} from "react-tippy";
import ShopSalesEditor from "../OperationList/ShopSalesEditor";
import ModalEditor from "../ModalEditor";
import FragmentEditor from "../FragmentEditor";
import TabContent from "../../layout/TabContent";
import Tabs from "../../layout/Tabs";
import is_numeric from 'locutus/php/var/is_numeric';
import ContentLoader from "../../layout/ContentLoader";

class MoneyTransferListExtend extends React.Component {

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
        this.listHidden && this.listHidden.refreshBackground();
    }

    refresh = () => {
        this.list && this.list.refresh();
        this.listHidden && this.listHidden.refresh();
    }

    render() {
        return (
            <Fragment>
                <MoneyTransferList ref={(list) => this.list = list} {...this.props} onLoadCompleted={() => {
                    this.listHidden && this.listHidden.refresh();
                }} />
                <div className="hidden" style={{display: "none"}}>
                    <MoneyTransferList ref={(list) => this.listHidden = list} {...this.props} gridid={this.props.gridid + "hidden"} pageSize={1} />
                </div>
            </Fragment>
        );
    }
}


class MoneyRepositoryClosing extends React.Component {

    state = {};

    refreshDom = {};

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (this.props.values[this.props.componentConfig.idfield] + "" !== "" + prevProps.values[this.props.componentConfig.idfield]) {
            const closings = [...(this.props.values.closings || []), ...(prevProps.values.closings || [])];
            const state = {};
            closings.map((closing, index) => {
                state["move." + index + ".items"] = [];
                state["move." + index + ".to"] = null;
            });
            this.setState(state);
        }
    }

    setFieldValue = (data) => {
        this.props.setFieldValue && this.props.setFieldValue("closings", data);
    }

    promisedSetState = (newState) => {
        return new Promise((resolve) => {
            this.setState(newState, () => {
                resolve()
            });
        });
    }

    moveItems = (e, index, componentConfig, moneyrepoComponentConfig) => {
        e && e.preventDefault();
        this.props.processAction(async () => {
            await Promise.all(((this.state || {})["move." + index + ".items"] || []).map((item) => {
                return postData({
                    action: "MoneyTransfer.update",
                    [componentConfig.idfield]: item[[componentConfig.idfield]],
                    data: {
                        moneyrepository: (this.state || {})["move." + index + ".to"]
                    }
                });
            }));
            const closings = (this.props.values.closings || []);
            Object.keys(this.refreshDom).map((key) => {
                this.refreshDom[key] && this.refreshDom[key].refreshBackground();
            });
            await this.promisedSetState({["move." + index + ".to"]: null, ["move." + index + ".items"]: []});
            index = closings.map((closing, i) => (closing.moneyrepository[moneyrepoComponentConfig.idfield] || closing.moneyrepository) + "" === "" + (this.state || {})["move." + index + ".to"] ? i : false).find((f) => f !== false);
            Object.keys(this.refreshDom).map((key) => {
                this.refreshDom[key] && this.refreshDom[key].refreshBackground();
            });
            return false;
        });
    }

    correctionData = (e, index, closing) => {
        const classes = calcClassName(closing);
        if (
            (classes.current > 1 && closing.current !== undefined && closing.current !== null && closing.current !== "")
            &&
            classes.total > 1 && closing.total !== undefined && closing.total !== null && closing.total !== ""
        ) {
            // tárgyi és a slejfni megegyezik
            const amount = (closing.amount || 0) - closing.current;
            if (amount !== 0) {
                return {
                    moneyrepository: closing.moneyrepository.repository_id,
                    amount: Math.abs(amount),
                    direction: amount < 0 ? -1 : 1
                };
            }
        } else if
        (
            classes.amount > 1 && closing.amount !== undefined && closing.amount !== null && closing.amount !== ""
            &&
            classes.total > 1 && closing.total !== undefined && closing.total !== null && closing.total !== ""
        ) {
            // tényleges és a slejfni megegyezik
            const amount = closing.current - (closing.total || closing.amount);
            if (amount !== 0) {
                return {
                    moneyrepository: closing.moneyrepository.repository_id,
                    amount: Math.abs(amount),
                    direction: amount < 0 ? 1 : -1
                }
            }
        }
        return {amount: 0};
    }

    correctTransfers = async (e, index, closing) => {
        await this.props.processAction(async () => {
            const data = this.correctionData(e, index, closing);
            if (data.amount !== 0) {
                await saveComponent("MoneyTransfer", data);
            }
            Object.keys(this.refreshDom).map((key) => {
                this.refreshDom[key] && this.refreshDom[key].refreshBackground();
            });
            return false;
        });
    }

    render() {
        this.refreshDom = {};
        const amountProps = this.props.getFieldProps("closings.amount");
        amountProps.disabled = amountProps.disabled || this.props.disabled;
        const totalProps = this.props.getFieldProps("closings.total");
        totalProps.disabled = totalProps.disabled || this.props.disabled;
        const invoiceTotalProps = this.props.getFieldProps("closings.invoice_total");
        invoiceTotalProps.disabled = invoiceTotalProps.disabled || this.props.disabled;
        const stornoProps = this.props.getFieldProps("closings.storno");
        stornoProps.disabled = stornoProps.disabled || this.props.disabled;
        const closings = (this.props.values.closings || []);
        if (this.props.initialValues.closings === undefined) {
            return <ContentLoader />;
        }
        const moneyrepositories = closings.map((closing) => closing.moneyrepository);
        return (
            <ComponentConfig componentName="moneyrepository">
                {(configProps) => <div className="row">
                    {closings.map((closing, index) => {
                        const values = {current: closing.current, amount: closing.amount, total: closing.total};
                        values.total = parseFloat(values.total);
                        if (closing.moneyrepository.component_type === "CreditCardTerminal") {
                            values.total += parseFloat(closing.invoice_total || 0);
                        }
                        values.total += parseFloat(closing.storno);
                        values.total = Math.round(values.total);
                        const classes = calcClassName(values);
                        let correctionData = this.correctionData(null, index, closing);
                        const isCorrectable = correctionData.amount !== 0;
                        return (
                            <div key={index} className={"col-md-" + Math.ceil(12 / closings.length)}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <Select
                                                {...this.props.getFieldProps("closings.moneyrepository")}
                                                label={false}
                                                name="moneyrepository"
                                                component="MoneyRepository"
                                                objectValue={false}
                                                labelKey="name"
                                                valueKey="repository_id"
                                                storeType="remote"
                                                value={closing.moneyrepository}
                                                disabled={true}
                                                saveChanges={(field, value) => {
                                                    const closing = JSON.parse(JSON.stringify(this.props.values.closings || []));
                                                    closing[index][field] = value;
                                                    this.setFieldValue(closing);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <ComponentConfig componentName="MoneyTransfer">
                                    {(MoneyTransferConfigProps) => <Fragment>
                                        {closing.moneyrepository.component_type === "CreditCardTerminal"
                                        ?
                                            <Fragment>
                                                <Tabs
                                                    theme="default"
                                                    currentTab="other"
                                                    renderAll={true}
                                                >
                                                    <TabContent tabLabel="Egyéb tételek" tabName="other">
                                                        <div className="row">
                                                            <MoneyTransferListExtend
                                                                ref={(d) => this.refreshDom[index + "other"] = d}
                                                                {...MoneyTransferConfigProps}
                                                                gridid={"MoneyTransferListClosing" + index}
                                                                showVisibleColumnFilter={false}
                                                                className={"p-small-table"}
                                                                filter={[{
                                                                            field: "invoice_count",
                                                                            value: 0
                                                                        }, {
                                                                    field: "moneyrepository",
                                                                    value: closing.moneyrepository[configProps.componentConfig.idfield]
                                                                }, ...this.props.dateFilters]}
                                                                onLoadCompleted={(response) => {
                                                                    const initialClosings = JSON.parse(JSON.stringify(this.props.initialValues.closings || []));
                                                                    const currentClosings = JSON.parse(JSON.stringify(closings));
                                                                    if (response.aggregations && response.aggregations[0]) {
                                                                        initialClosings[index].real_amount = currentClosings[index].real_amount = response.aggregations[0].total || 0;
                                                                    } else {
                                                                        initialClosings[index].real_amount = currentClosings[index].real_amount = 0;
                                                                    }
                                                                    initialClosings[index].pristine = currentClosings[index].pristine = "" + Math.round(parseFloat(currentClosings[index].real_amount || 0) + parseFloat(currentClosings[index].invoice_total || 0));
                                                                    initialClosings[index].current = currentClosings[index].current = "" + Math.round(parseFloat(currentClosings[index].open || 0) + parseFloat(currentClosings[index].pristine || 0));
                                                                    this.props.setFieldValue("closings", currentClosings);
                                                                    this.props.setInitialValues({...this.props.initialValues, closings: initialClosings});
                                                                }}
                                                                selectionMode="multiple"
                                                                onSelectionChange={(data) => this.setState({["move." + index + ".items"]: data.value})}
                                                                selection={(this.state || {})["move." + index + ".items"] || []}
                                                            />
                                                        </div>
                                                    </TabContent>
                                                    <TabContent tabLabel="Számlás tételek" tabName="invoice">
                                                        <div className="row">
                                                            <MoneyTransferListExtend
                                                                ref={(d) => this.refreshDom[index + "invoice"] = d}
                                                                {...MoneyTransferConfigProps}
                                                                gridid={"MoneyTransferListClosing" + index}
                                                                showVisibleColumnFilter={false}
                                                                className={"p-small-table"}
                                                                filter={[{
                                                                            field: "invoice_count",
                                                                            value: 0,
                                                                            operator: ">"
                                                                        }, {
                                                                    field: "moneyrepository",
                                                                    value: closing.moneyrepository[configProps.componentConfig.idfield]
                                                                }, ...this.props.dateFilters]}
                                                                onLoadCompleted={(response) => {
                                                                    const initialClosings = JSON.parse(JSON.stringify(this.props.initialValues.closings || []));
                                                                    const currentClosings = JSON.parse(JSON.stringify(closings));
                                                                    if (!this.props.values[this.props.componentConfig.idfield]) {
                                                                        if (response.aggregations && response.aggregations[0]) {
                                                                            initialClosings[index].invoice_total = currentClosings[index].invoice_total = response.aggregations[0].total || 0;
                                                                        } else {
                                                                            initialClosings[index].invoice_total = currentClosings[index].invoice_total = 0;
                                                                        }
                                                                    }
                                                                    initialClosings[index].pristine = currentClosings[index].pristine = "" + Math.round(parseFloat(currentClosings[index].real_amount || 0) + parseFloat(currentClosings[index].invoice_total || 0));
                                                                    initialClosings[index].current = currentClosings[index].current = "" + Math.round(parseFloat(currentClosings[index].open || 0) + parseFloat(currentClosings[index].pristine || 0));
                                                                    this.props.setFieldValue("closings", currentClosings);
                                                                    this.props.setInitialValues({...this.props.initialValues, closings: initialClosings});
                                                                }}
                                                                selectionMode="multiple"
                                                                onSelectionChange={(data) => this.setState({["move." + index + ".items"]: data.value})}
                                                                selection={(this.state || {})["move." + index + ".items"] || []}
                                                            />
                                                        </div>
                                                    </TabContent>
                                                </Tabs>
                                            </Fragment>
                                        :
                                            <Fragment>
                                                <Tabs
                                                    theme="default"
                                                    currentTab="other"
                                                    renderAll={true}
                                                >
                                                    <TabContent tabLabel="Tételek" tabName="other">
                                                        <div className="row">
                                                            <MoneyTransferListExtend
                                                                ref={(d) => this.refreshDom[index + ""] = d}
                                                                {...MoneyTransferConfigProps}
                                                                gridid={"MoneyTransferListClosing" + index}
                                                                showVisibleColumnFilter={false}
                                                                className={"p-small-table"}
                                                                filter={[{
                                                                    field: "moneyrepository",
                                                                    value: closing.moneyrepository[configProps.componentConfig.idfield]
                                                                }, ...this.props.dateFilters]}
                                                                onLoadCompleted={(response) => {
                                                                    const initialClosings = JSON.parse(JSON.stringify(this.props.initialValues.closings || []));
                                                                    const currentClosings = JSON.parse(JSON.stringify(closings));
                                                                    if (response.aggregations && response.aggregations[0]) {
                                                                        initialClosings[index].pristine = currentClosings[index].pristine = response.aggregations[0].total || 0;
                                                                    } else {
                                                                        initialClosings[index].pristine = currentClosings[index].pristine = 0;
                                                                    }
                                                                    initialClosings[index].current = currentClosings[index].current = parseFloat(currentClosings[index].open || 0) + parseFloat(currentClosings[index].pristine || 0);
                                                                    this.props.setFieldValue("closings", currentClosings);
                                                                    this.props.setInitialValues({...this.props.initialValues, closings: initialClosings});
                                                                }}
                                                                selectionMode="multiple"
                                                                onSelectionChange={(data) => this.setState({["move." + index + ".items"]: data.value})}
                                                                selection={(this.state || {})["move." + index + ".items"] || []}
                                                            />
                                                        </div>
                                                    </TabContent>
                                                </Tabs>
                                            </Fragment>
                                        }
                                        <div className="hidden" style={{display: "none"}}>
                                            {isFalse(closing.moneyrepository.virtual) && <MoneyTransferListExtend
                                                ref={(d) => this.refreshDom[index + "open"] = d}
                                                {...MoneyTransferConfigProps}
                                                gridid={"MoneyTransferListClosingOpen" + index}
                                                showVisibleColumnFilter={false}
                                                className={"p-small-table"}
                                                filter={[{
                                                    field: "moneyrepository",
                                                    value: closing.moneyrepository[configProps.componentConfig.idfield]
                                                }, ...this.props.openCurrentFilter]}
                                                onLoadCompleted={(response) => {
                                                    const initialClosings = JSON.parse(JSON.stringify(this.props.initialValues.closings || []));
                                                    const currentClosings = JSON.parse(JSON.stringify(closings));
                                                    if (response.aggregations && response.aggregations[0]) {
                                                        initialClosings[index].open = currentClosings[index].open = response.aggregations[0].total || 0;
                                                    } else {
                                                        initialClosings[index].open = currentClosings[index].open = 0;
                                                    }
                                                    initialClosings[index].current = currentClosings[index].current = parseFloat(currentClosings[index].open || 0) + parseFloat(currentClosings[index].pristine || 0);
                                                    this.props.setFieldValue("closings", currentClosings);
                                                    this.props.setInitialValues({...this.props.initialValues, closings: initialClosings});
                                                }}
                                            />}
                                        </div>
                                        {!!((this.state || {})["move." + index + ".items"] || []).length && <div className="form-group">
                                            <div className="row form-row">
                                                <div className="col-md-6">
                                                    <Select
                                                        {...this.props.getFieldProps("closings.moneyrepository")}
                                                        label={false}
                                                        placeholder="Áthelyezés helye"
                                                        name="moneyrepository"
                                                        component="MoneyRepository"
                                                        objectValue={false}
                                                        labelKey="name"
                                                        valueKey="repository_id"
                                                        storeType="local"
                                                        disabled={this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                                                        options={[...moneyrepositories].filter((moneyrepository) => moneyrepository[configProps.componentConfig.idfield] + "" !== "" + closing.moneyrepository[configProps.componentConfig.idfield])}
                                                        value={(this.state || {})["move." + index + ".to"] || null}
                                                        saveChanges={(field, value) => this.setState({["move." + index + ".to"]: value})}
                                                    />
                                                </div>
                                                <div className="col-md-6">
                                                    <Button block={true} disabled={this.props.values[this.props.componentConfig.idfield] || this.props.isLoading || !((this.state || {})["move." + index + ".to"] || null)} color="warning" onClick={(e) => this.moveItems(e, index, MoneyTransferConfigProps.componentConfig, configProps.componentConfig)}>
                                                        Áthelyezés
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>}
                                    </Fragment>}
                                </ComponentConfig>
                                <div className="row">
                                    <div className={classNames("col-md-6", {"col-lg-4": closing.moneyrepository.component_type !== "CreditCardTerminal", "col-lg-3": closing.moneyrepository.component_type === "CreditCardTerminal"})}>
                                        <div className="form-group currency">
                                            <label className="control-label nowrap">Tárgyi egyenleg <Icon lib="fas" name="calculator" tooltip="A rendszerben lévő összeg" /></label>
                                            <div className={classNames({"input-group": isCorrectable})}>
                                                <Tooltip title={
                                                    closing.moneyrepository.component_type === "CreditCardTerminal"
                                                    ?
                                                        CurrencyFormatter(closing.open || 0).props.children + " + " + CurrencyFormatter(closing.real_amount || 0).props.children + " + " + CurrencyFormatter(closing.invoice_total || 0).props.children + " = " + CurrencyFormatter(parseFloat(closing.open || 0) + parseFloat(closing.pristine || 0)).props.children
                                                    :
                                                        CurrencyFormatter(closing.open || 0).props.children + " + " + CurrencyFormatter(closing.pristine || 0).props.children + " = " + CurrencyFormatter(parseFloat(closing.open || 0) + parseFloat(closing.pristine || 0)).props.children
                                                }>
                                                    <TextInput
                                                        name="current"
                                                        type="decimal"
                                                        value={parseFloat(closing.current || 0)}
                                                        formatter={CurrencyFormatter}
                                                        className={classNames({
                                                            "success": (classes.current > 1 && closing.current !== undefined && closing.current !== null && closing.current !== ""),
                                                            "error": classes.current <= 1 || closing.current === undefined || closing.current === null || closing.current === ""
                                                        })}
                                                        label={false}
                                                        {...this.props.getFieldProps("closings.current")}
                                                        disabled={true}
                                                    />
                                                </Tooltip>
                                                {isCorrectable && <span className="input-group-btn">
                                                    <Portal>
                                                        <Modal
                                                            header="Korrekció"
                                                            ref={(modal) => this["modal" + index] = modal}
                                                            disabled={this.props.isLoading}
                                                            buttons={[
                                                                {
                                                                    text: "Mégse",
                                                                    props: {color: "default", disabled: this.props.isLoading},
                                                                    onClose: true,
                                                                    onClick: () => {
                                                                        this["modal" + index] && this["modal" + index].hide();
                                                                    }
                                                                },
                                                                {
                                                                    text: "Igen, ezt akarom",
                                                                    props: {color: "danger", disabled: this.props.isLoading},
                                                                    onClick: async (e) => {
                                                                        await this.correctTransfers(e, index, closing);
                                                                        this["modal" + index] && this["modal" + index].hide();
                                                                    }
                                                                }
                                                            ]}
                                                        >
                                                             <b>{correctionData.direction < 0 ? "Csökkenteni" : "Növelni"}</b> fogod <b>{CurrencyFormatter(correctionData.amount).props.children}</b>-al a tárgyi egyenleget! Biztos ezt akarod?
                                                        </Modal>
                                                    </Portal>
                                                    <Button
                                                        icon={{lib: "fas", name: "check-double"}}
                                                        tooltip={"Korrekció"}
                                                        color="warning"
                                                        onClick={() => this["modal" + index] && this["modal" + index].show()}
                                                        disabled={this.props.isLoading || this.props.disabled === "true" || this.props.disabled === "disabled" || this.props.disabled}
                                                    />
                                                </span>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={classNames("col-md-6", {"col-lg-4": closing.moneyrepository.component_type !== "CreditCardTerminal", "col-lg-3": closing.moneyrepository.component_type === "CreditCardTerminal"})}>
                                        <div className="form-group currency">
                                            <TextInput
                                                name="amount"
                                                type="decimal"
                                                value={closing.amount}
                                                formatter={CurrencyFormatter}
                                                disabled={this.props.isLoading}
                                                disablePaste={true}
                                                className={classNames({
                                                    "success": classes.amount > 1 && closing.amount !== undefined && closing.amount !== null && closing.amount !== "",
                                                    "error": classes.amount <= 1 || closing.amount === undefined || closing.amount === null || closing.amount === ""
                                                })}
                                                label={<span className="nowrap">Tényleges egyenleg <Icon lib="fas" name="money-bill-alt" tooltip="Tényleges pénzösszeg" /></span>}
                                                {...amountProps}
                                                saveChanges={(field, value) => {
                                                    const closing = JSON.parse(JSON.stringify(this.props.values.closings || []));
                                                    closing[index][field] = value;
                                                    this.setFieldValue(closing);
                                                }}/>
                                        </div>
                                    </div>
                                    <div className={classNames("col-md-12", {"col-lg-4": closing.moneyrepository.component_type !== "CreditCardTerminal", "col-lg-6": closing.moneyrepository.component_type === "CreditCardTerminal"})}>
                                        <div className="row">
                                            <div className={classNames({"col-md-12": closing.moneyrepository.component_type !== "CreditCardTerminal", "col-md-6": closing.moneyrepository.component_type === "CreditCardTerminal"})}>
                                                <div className="form-group currency">
                                                    <TextInput
                                                        name="total"
                                                        type="decimal"
                                                        value={closing.total}
                                                        formatter={CurrencyFormatter}
                                                        disabled={this.props.isLoading}
                                                        disablePaste={true}
                                                        className={classNames({
                                                            "success": classes.total > 1 && closing.total !== undefined && closing.total !== null && closing.total !== "",
                                                            "error": classes.total <= 1 || closing.total === undefined || closing.total === null || closing.total === ""
                                                        })}
                                                        label={<span className="nowrap">Pénztárgép záró <Icon lib="fas" name="toilet-paper" tooltip="A pénztárgép által kiadott szalagon lévő összeg" /></span>}
                                                        {...totalProps}
                                                        saveChanges={(field, value) => {
                                                            const closing = JSON.parse(JSON.stringify(this.props.values.closings || []));
                                                            closing[index][field] = value;
                                                            this.setFieldValue(closing);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            {closing.moneyrepository.component_type === "CreditCardTerminal" && <div className={classNames({"col-md-12": closing.moneyrepository.component_type !== "CreditCardTerminal", "col-md-6": closing.moneyrepository.component_type === "CreditCardTerminal"})}>
                                                <div className="form-group currency">
                                                    <TextInput
                                                        name="invoice_total"
                                                        type="decimal"
                                                        value={closing.invoice_total}
                                                        formatter={CurrencyFormatter}
                                                        disablePaste={true}
                                                        className={classNames({
                                                            "success": (!isNaN(closing.invoice_total) && closing.invoice_total === closing.invoice_total) && (classes.total > 1 && closing.total !== undefined && closing.total !== null && closing.total !== ""),
                                                            "error": !(!isNaN(closing.invoice_total) && closing.invoice_total === closing.invoice_total) || (classes.total <= 1 || closing.total === undefined || closing.total === null || closing.total === "")
                                                        })}
                                                        label={<span className="nowrap">Számlás eladások <Icon lib="fas" name="file-invoice-dollar" tooltip="Számlás eladások összege" /></span>}
                                                        {...invoiceTotalProps}
                                                        disabled={true}
                                                        saveChanges={(field, value) => {
                                                            const closing = JSON.parse(JSON.stringify(this.props.values.closings || []));
                                                            closing[index][field] = value;
                                                            this.setFieldValue(closing);
                                                        }}
                                                    />
                                                </div>
                                            </div>}
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group currency">
                                                    <TextInput
                                                        name="storno"
                                                        type="decimal"
                                                        value={closing.storno}
                                                        formatter={CurrencyFormatter}
                                                        disabled={this.props.isLoading}
                                                        disablePaste={true}
                                                        className={classNames({
                                                            "success": is_numeric(closing.storno),
                                                            "error": !is_numeric(closing.storno)
                                                        })}
                                                        negative={true}
                                                        label={<span className="nowrap">Sztornó összeg <Icon lib="fas" name="band-aid" tooltip="Elütésekből vagy egyéb problémákból keletkezett helyesbítések" /></span>}
                                                        {...stornoProps}
                                                        saveChanges={(field, value) => {
                                                            const closing = JSON.parse(JSON.stringify(this.props.values.closings || []));
                                                            closing[index][field] = value;
                                                            this.setFieldValue(closing);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>}
            </ComponentConfig>
        );
    }
}

class VatRateClosing extends React.Component {

    setFieldValue = (data) => {
        this.props.setFieldValue && this.props.setFieldValue("vatrate_closings", data)
    }

    render() {
        const vatrate_closings = (this.props.values.vatrate_closings || []);
        const amount = !vatrate_closings.length ? undefined : vatrate_closings.map((vatrate_closing) => vatrate_closing.amount).reduce((sum, amount) => parseFloat(sum || "0") + parseFloat(amount || "0"));
        return (
            !!vatrate_closings.length && <Fragment>
                <label className="control-label">Gyűjtők</label>
                <div className="row">
                    {
                        vatrate_closings.map((closing, index) => {
                            const amountProps = this.props.getFieldProps("closings.amount");
                            amountProps.disabled = amountProps.disabled || this.props.disabled;
                            return (
                                <div key={index} className={"col-md-" + Math.ceil(12 / vatrate_closings.length)}>
                                    <div className="form-group currency">
                                        <TextInput
                                            name="amount"
                                            type="decimal"
                                            value={closing.amount}
                                            disablePaste={true}
                                            label={closing.vatrate.name}
                                            disabled={this.props.isLoading}
                                            formatter={CurrencyFormatter}
                                            required={true}
                                            className={classNames({
                                                "success": amount + "" === "" + this.props.values.total && amount !== undefined && this.props.values.total !== undefined && closing.amount !== null && closing.amount !== undefined && closing.amount !== "",
                                                "error": amount + "" !== "" + this.props.values.total || amount === undefined || this.props.values.total === undefined || closing.amount === null || closing.amount === undefined || closing.amount === ""
                                            })}
                                            {...amountProps}
                                            saveChanges={(field, value) => {
                                                const vatrate_closings = JSON.parse(JSON.stringify(this.props.values.vatrate_closings || []));
                                                vatrate_closings[index][field] = value;
                                                this.setFieldValue(vatrate_closings);
                                            }}
                                        />
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            </Fragment>
        );
    }
}

class TillClosingForm extends React.Component {

    state = {
        total: 0,
        count: 0,
        opening: 0
    };

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (!this.props.values[this.props.componentConfig.idfield]) {
            let till = this.props.values.till;
            let closings = this.props.values.closings;
            let vatrate_closings = this.props.values.vatrate_closings;
            if (!isEqual((prevProps.till || {}).id, (this.props.till || {}).id) || !isEqual((this.props.values.till || {}).id, (this.props.till || {}).id) || this.props.initialValues.closings === undefined) {
                till = this.props.till;
                this.props.setFieldValue("till", till);
                this.props.setInitialValues({...this.props.values, till});
                closings = this.props.till.moneyrepositories.map((moneyrepository) => {
                    return {moneyrepository};
                });
                this.props.setFieldValue("closings", closings);
                this.props.setInitialValues({...this.props.values, closings});
                vatrate_closings = this.props.till.vatrates.map((vatrate) => {
                    return {vatrate};
                });
                this.props.setFieldValue("vatrate_closings", vatrate_closings);
                this.props.setInitialValues({...this.props.values, vatrate_closings});

                this.closing_date && this.closing_date.abort();
                this.closing_date = sendRequest({
                    component: "TillClosing",
                    option: "componentlist",
                    view: ["closing_date"],
                    page: 1,
                    itemsperpage: 1,
                    filter: [{field: "till", value:till.id}],
                    order: [{field: "closing_date", direction: "DESC"}],
                });
                this.closing_date.then((response) => {
                    if (response.items[0]) {
                        this.props.setFieldValue("before_closing_date", response.items[0].closing_date);
                        this.props.setInitialValues({...this.props.values, before_closing_date: response.items[0].closing_date});
                    }
                });
            }
            if (this.props.values.closings === null || this.props.values.closings === undefined) {
                closings = this.props.till.moneyrepositories.map((moneyrepository) => {
                    return {moneyrepository};
                });
                this.props.setFieldValue("closings", closings);
                this.props.setInitialValues({...this.props.values, closings});
            }
            if (this.props.values.vatrate_closings === null || this.props.values.vatrate_closings === undefined) {
                vatrate_closings = this.props.till.vatrates.map((vatrate) => {
                    return {vatrate};
                });
                this.props.setFieldValue("vatrate_closings", vatrate_closings);
                this.props.setInitialValues({...this.props.values, vatrate_closings});
            }
        }
    }

    render() {
        const tillProps = this.props.getFieldProps("till");
        const closings = (this.props.values.closings || []);
        const sumFilter = closings.map((closing) => ({field: "moneyrepository", value: closing.moneyrepository.repository_id}));
        const dateFilters = [];
        const openCurrentFilter = [];
        if (this.props.values.before_closing_date) {
            dateFilters.push({field: "transferdate", value: this.props.values.before_closing_date, operator: ">"});
            openCurrentFilter.push({
                field: "transferdate",
                value: this.props.values.before_closing_date,
                operator: "<"
            });
        } else if (this.props.values[this.props.componentConfig.idfield]) {
            openCurrentFilter.push({
                field: "transferdate",
                value: 1,
                operator: "<"
            });
        }
        if (this.props.values[this.props.componentConfig.idfield]) {
            dateFilters.push({field: "transferdate", value: this.props.values.closing_date, operator: "<="});
        } else if (this.props.values.after_closing_date) {
            dateFilters.push({field: "transferdate", value: this.props.values.after_closing_date, operator: "<"});
        }
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-md-4 col-md-push-8">
                        <div className="form-group">
                            <TextInput
                                name={this.props.componentConfig.idfield}
                                value={this.props.values[this.props.componentConfig.idfield]}
                                label="Kód"
                                role="idfield"
                                {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                            />
                        </div>
                    </div>
                    <div className="col-md-8 col-md-pull-4">
                        <div className="form-group">
                            <Select
                                objectValue={false}
                                name="till"
                                value={this.props.values.till}
                                labelKey="displayname"
                                component="Till"
                                storeType="local"
                                saveChanges={this.props.setFieldValue}
                                label="Eladási pont"
                                {...tillProps}
                                disabled={this.props.till || tillProps.disabled}
                            />
                        </div>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-6">
                        <TextInput
                            name="closing_number"
                            value={this.props.values.closing_number}
                            label="Zárásszám"
                            required={true}
                            className={classNames({
                                "success": !isEmpty(this.props.values.closing_number),
                                "error": isEmpty(this.props.values.closing_number)
                            })}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("closing_number")}
                        />
                    </div>
                    <div className="col-md-3">
                        <TextInput
                            name="transaction_count"
                            value={this.props.values.transaction_count}
                            formatter={UnitFormatter}
                            label="Tranzakciószám"
                            required={true}
                            className={classNames({
                                "success": is_numeric(this.props.values.transaction_count),
                                "error": !is_numeric(this.props.values.transaction_count)
                            })}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("transaction_count")}
                        />
                    </div>
                    <div className="col-md-3">
                        <TextInput
                            disabled={true}
                            value={this.state.count}
                            formatter={UnitFormatter}
                            label="Tranzakciók száma"
                        />
                    </div>
                </div>
                {closings.length > 1 ? <Fragment>
                    <div className="row form-row">
                        <div style={{display: "none"}} className="hidden">
                            {this.props.values.before_closing_date && <ComponentConfig componentName="MoneyTransfer">
                                {(props) =>
                                    <MoneyTransferList
                                        {...props}
                                        onLoadCompleted={(response) => {
                                            if (response.aggregations && response.aggregations[0]) {
                                                this.setState({opening: response.aggregations[0].total || 0});
                                            } else {
                                                this.setState({opening: 0});
                                            }
                                        }}
                                        filter={[...(sumFilter.length ? [{operator: "OR", filters: sumFilter}] : []),...(this.props.values.before_closing_date ? [{field: "transferdate", value: this.props.values.before_closing_date, operator: "<"}] : [])]}
                                    />}
                            </ComponentConfig>}
                        </div>
                        <div className="col-md-12">
                            <div className="form-group">
                                <Button block={true} color="default" onClick={() => this.setState({opened: !this.state.opened})}>
                                    Összes tranzakció {CurrencyFormatter(this.state.total).props.children} <span className="caret"/>
                                </Button>
                                <Collapse collapsed={!!this.state.opened}>
                                    <div>
                                        <ComponentConfig componentName="MoneyTransfer">
                                            {(props) =>
                                            <MoneyTransferList
                                                {...props}
                                                onLoadCompleted={(response) => {
                                                    if (response.aggregations && response.aggregations[0]) {
                                                        this.setState({total: response.aggregations[0].total || 0, count: response.aggregations[0].total_count || 0});
                                                    } else {
                                                        this.setState({total: 0, count: 0});
                                                    }
                                                }}
                                               filter={[...(sumFilter.length ? [{operator: "OR", filters: sumFilter}] : []),...dateFilters]}
                                            />}
                                        </ComponentConfig>
                                    </div>
                                </Collapse>
                            </div>
                        </div>
                    </div>
                </Fragment> : null}
                <MoneyRepositoryClosing {...this.props} disabled={!!this.props.values[this.props.componentConfig.idfield]} dateFilters={dateFilters} openCurrentFilter={openCurrentFilter}/>
                {/*<ShopSalesEditor
                    editor={ModalEditor}
                    list={(props) => <Fragment>
                        <label className="control-label">Félbe hagyott eladások</label>
                        {props.children}
                    </Fragment>}
                    closing={dateFilters.map((filter) => {
                        filter = {...filter};
                        filter.field = "created_at";
                        return filter;
                    })}
                />*/}
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group currency">
                            <TextInput
                                name="total"
                                value={this.props.values.total}
                                disabled={this.props.isLoading}
                                formatter={CurrencyFormatter}
                                label="Forgalom"
                                className={classNames({
                                    "success": is_numeric(this.props.values.total),
                                    "error": !is_numeric(this.props.values.total)
                                })}
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("total")}
                            />
                        </div>
                    </div>
                </div>
                <VatRateClosing {...this.props} disabled={!!this.props.values[this.props.componentConfig.idfield]} />
                <TextArea
                    disabled={this.props.isLoading}
                    name="comment"
                    value={this.props.values.comment}
                    label="Megjegyzés"
                    saveChanges={this.props.setFieldValue}
                    {...this.props.getFieldProps("comment")}
                />
            </form>
        );
    }
}

export default createForm(TillClosingForm);
